function RegisterCtrl(
  $scope,
  $sce,
  $state,
  $http,
  CoreService,
  UserService,
  Cause,
  Subscriber,
  Subscription,
  AccountService,
  Key,
  AppAuthFactory,
  ConfigEnvironment,
  ReferrerService,
  currentUser,
  $rootScope,
  $timeout){
  "ngInject";

  var vm = this;


  vm.checkInputs = function checkInputs() {
    console.log('checking');
    let { first_name, last_name, username, password } = this.registration;

    let fn = value => {
      return value && value.length > 0;
    };

    let usernameInputs = [username ].filter(fn),
      passwordInputs = [ password ].filter(fn);
    console.log(usernameInputs.length, passwordInputs.length);

    vm.showUserNameMessage = (usernameInputs.length < 2) ? true : false;
    vm.showPasswordMessage = (passwordInputs.length < 2) ? true : false;
  };

  vm.resetCheckInputs = function resetCheckInputs() {
    vm.showUserNameMessage = false;
    vm.showPasswordMessage = false;
  };

  vm.registration = {
    first_name: '',
    last_name: '',
    username: '',
    password: '',
    is_agreed_to: false,
    //subscriber_id: 777,
    subscriber_id: null,
    //the string value of the key
    membership_key: '',
    //used to store the cause object
    selected_cause: false,
    //the object of the key for unassociated keys
    registered_key: false,
    // referrer id
    referred_by: null
  };

  if(currentUser.id && !vm.registration.subscriber_id) {
    angular.extend(vm.registration, {
      subscriber_id: currentUser.id,
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      username: currentUser.email,
      is_agreed_to: true,
      referred_by: ReferrerService.getReferredBy()
    });
    console.log("repopulating scope.registration from currentUser", vm.registration, currentUser);
  }

  //stores an array of causes to select from
  vm.causes = [];

  //used for email verification
  vm.verification = {
    uid: null,
    token: null
  };

  //used for form validation messages
  vm.criteria = {
    password: AccountService.getCriteria('password')
  }

  vm.hasRegisteredAssociatedKey = false;
  vm.hasRegisteredInvalidKey = false;
  vm.hasMembershipKey = false;

  vm.verifySubscriber = verifySubscriber;
  vm.prepareCauseForDisplay = prepareCauseForDisplay;
  vm.selectCause = selectCause;
  vm.confirmCause = confirmCause;
  vm.registerAccountAndKey = registerAccountAndKey;
  vm.displayCauseSelection = displayCauseSelection;
  vm.validateMembershipKey = _validateMembershipKey;
  vm.registerAccount = registerAccount;

  //PUBLIC FUNCTIONS
  function verifySubscriber() {
    Subscriber.confirm({
      "uid": vm.verification.uid,
      "token": vm.verification.token
    }).$promise.then((response) => {
      $state.go("login.verified");
    }).catch((response) => {
      let errorCode;
      try {
        errorCode = response.data.error.code;
      } catch(e) {}
      $state.go("error.500", {errMsg: `Either the account is invalid or was already verified. Please try again. If the error persists, select Report Error and let us help you resolve the issue! ${errorCode}`});
    });
  }

  function prepareCauseForDisplay(cause) {
    cause.description = $sce.trustAsHtml(cause.description);
    return cause;
  };

  function displayCauseSelection() {
    vm.registration.selected_cause = false;
    vm.registration.registered_key = false;
    vm.hasRegisteredAssociatedKey = false;
    vm.hasRegisteredInvalidKey = false;
  };

  function selectCause(cause) {
    vm.registration.selected_cause = cause;
  };

  function confirmCause() {
    //cause selected but has no key
    if(!vm.paymentRoute) {
      vm.paymentRoute = "join.selectpayment";
    }
    if(vm.registration.selected_cause && !vm.registration.registered_key) {
      $state.go(vm.paymentRoute);
    }
    //entered key and selected a cause
    else if(vm.registration.selected_cause && vm.registration.registered_key) {
      createSubscription(function(err, subscription) {
        if(err) return $state.go('error.500', {errMsg: "There was an error creating your subscription. Please try again. If the error persists, select Report Error and let us help you resolve the issue!"});
        $state.go("dashboard.home");
        $timeout(() => {
          window.location.reload()
        }, 250);
      });
    }
  };

  function registerAccountAndKey() {
    vm.validationError = false;
    $rootScope.$emit('show:loadingPopup');
    _validateMembershipKey(function(response, key) {
      let errCode;
      try {
        errCode = response.data.error.code;
      } catch(e) {}

      if(errCode == "KEY_NOT_FOUND") {
        $rootScope.$emit('hide:loadingPopup');
        vm.validationError = true;
      }
      else if(response) {
        $rootScope.$emit('hide:loadingPopup');
        return $state.go('error.500', {errMsg: "There was an error validating the membership key that was entered. Please try again. If the error persists, select Report Error and let us help you resolve the issue!"});
      }
      else {
        vm.hasMembershipKey = true;
        _registerAccount(vm, (subscriber) => {
          $rootScope.$emit('hide:loadingPopup');
          if(!vm.validationError) {
            $state.go("join.registeredkeycause");
          }
        });
      }
    });
  };

  function registerAccount() {
    $rootScope.$emit('show:loadingPopup');
    _registerAccount(vm, (subscriber) => {
      $rootScope.$emit('hide:loadingPopup');
      if(!vm.validationError) {
        $state.go("join.memberkeycause");
      }
    });
  };

  function createSubscription(callback) {

    var key = vm.registration.registered_key;
    var cause = vm.registration.selected_cause;

    if(!key || !cause) throw Error("Key or cause is null");

    var today = new Date();
    var oneYearFromNow = new Date();
    oneYearFromNow.setYear(today.getFullYear() + 1);

    if(vm.registration.referred_by) {
      vm.registration.referred_by.realm = "greenback_join_process";
    }

    Subscription.create({
      "key_id": key.id,
      "subscriber_id": vm.registration.subscriber_id,
      "program_id": key.program_id,
      "cause_id": cause.id,
      "subentity_id": vm.registration.referred_by && vm.registration.referred_by.subentity_id,
      "amount": key.program.sales_price,
      "expires": oneYearFromNow.toISOString(),
      "referred_by": vm.registration.referred_by
    }).$promise.then(function(subscription) {
      subscription = subscription.toJSON();
      console.log(subscription);
      subscription.cause = cause;
      callback(null, subscription);
    }).catch(function(subscriptionErr) {
      callback(subscriptionErr);
    });
  };

  //PRIVATE FUNCTIONS

  function _validateMembershipKey(callback) {

    vm.hasRegisteredInvalidKey = false;

    console.log("validateMembershipKey", vm.registration.membership_key);

    function _handleErr(response) {
      try {
        response.data.error.code = "KEY_NOT_FOUND";
      } catch(e) {}
      vm.hasRegisteredInvalidKey = true;
      callback && callback(response);
    }

    Key.findOneSecure({
      "filter": {
        "where": {
          "and": [
            {"membership_key": vm.registration.membership_key},
            {"is_sold": false}
          ]
        },
        "include": ["cause","program"]
      },
    }).$promise.then((response) => {

      if((response.data && response.data.error) || response.error) {
       return _handleErr(response)
      }

      vm.registration.registered_key = response;
      //associated to no cause
      if(!angular.isNumber(response.cause_id)) {
        //exclusive from hasMembershipKey
        vm.hasRegisteredUnassociatedKey = true;
      }
      //associated to one cause
      else {
        var key = response.toJSON();
        var cause = key.cause;
        vm.registration.selected_cause = prepareCauseForDisplay(cause);
        vm.registration.registered_key = key;
        vm.hasRegisteredAssociatedKey = true;
        callback && callback(undefined, key);
      }
    }).catch((response) => {
      return _handleErr(response)
    });
  };

  function _registerAccount(vm, successCallback) {

    vm.validationError = false;

    if(
      vm.registration.first_name &&
      vm.registration.last_name &&
      vm.registration.username &&
       vm.registration.password ){

      vm.validationError = false;

      //to catch non html5 browsers
      if(!AccountService.matchesCriteriaPassword(vm.registration.password)) {
        vm.validationError = vm.criteria.password;
      }

      if(vm.validationError) {
         successCallback(vm.validationError);
      } else {

        if(ReferrerService.hasReferrer()) {
          vm.registration.referred_by = ReferrerService.getReferredBy();
        }

        UserService.register(vm.registration, function(subscriber) {
          vm.registration.subscriber_id = subscriber.id;
          $timeout(() => {
            Subscriber.login(
              {
                include: 'user',
                rememberMe: true
              },
              {
                "first_name": vm.registration.first_name,
                "last_name": vm.registration.last_name,
                "email": vm.registration.username,
                "password": vm.registration.password
              },
              function () {
                $timeout(() => {
                  successCallback(undefined, subscriber);
                }, 333);
              },
              function (err) {
                //there was an issue authenticating the user
                successCallback(err);
              }
            );
          }, 333);
        }, function(errMessage) {
          vm.validationError = errMessage;
          successCallback(errMessage);
        });
      }
    }
  }
}

export default RegisterCtrl;



// WEBPACK FOOTER //
// ./js/containers/users/controllers/register.ctrl.js